module.exports = __webpack_public_path__ + "img/layout-6_6.3a3184aa.png";